import { toastNotifications } from '@uag/react-core';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useGetAutomatedConnectorPlacement } from 'app/modules/wallforming/components/setting-container/hooks/useGetAutomatedConnectorPlacement';

export const useHandleConnectorPlacement = () => {
    const { t } = useTranslation();

    const [isLoading, setIsLoading] = useState<boolean>(false);

    const runAutomatedConnectorPlacement = useGetAutomatedConnectorPlacement({
        setLoadingState: setIsLoading
    });

    const handleConnectorPlacementStart = useCallback(() => {
        if (isLoading) {
            return;
        }

        toastNotifications.information({ title: t('info'), message: t('infoLoadingAutoConnectorPlacement') });
        void runAutomatedConnectorPlacement();
    }, [isLoading, runAutomatedConnectorPlacement, t]);

    return { handleConnectorPlacementStart, isLoading };
};
